import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div data-test-heartbeat-websocket-listener>\n</div>",{ moduleName: "bullitttime-event/components/heartbeat-websocket-listener.hbs" })